























































































import api from "@/api/index"; //ABP API接口
import {Component, Vue} from "vue-property-decorator";
import PagedTableView from "@/components/PagedTableView/index.vue";
import {DataDictionaryDtoPagedResultDto, DataDictionaryDto, TrainStatus} from "@/api/appService";
import AbSelect from "@/components/AbSelect/index.vue";
import AgileAuditTag from "@/components/AgileAuditTag/index.vue";
import ExportButton from "@/components/ExportButton/index.vue";

@Component({
  name: "TrainList",
  components: {
    ExportButton,
    PagedTableView,
    AbSelect,
    AgileAuditTag
  }
})
export default class TrainList extends Vue {
  typeList:DataDictionaryDto[]=[];
  queryForm: any = {
    title: undefined,
    trainTypeId:undefined,
    status: TrainStatus.Published,
    startDate:undefined,
    endDate:undefined
  }
  exportApplyFieldList = [
    "志愿者编号",
    "姓名",
    "性别",
    "手机号",
    "居住地",
    "报名时间",
    "志愿者星级",
    "志愿者积分",
    "签到次数",
    "状态"
  ];
  exportFieldList = [
    "志愿者编号",
    "姓名",
    "性别",
    "手机号",
    "签到时间"
  ];
  created(){
    this.fetchDataDictionary()
  }

  // 获取表数据
  async fetchData(params: any) {
    params.status=TrainStatus.Published;
    return await api.train.getAll(params);
  }

  async fetchDataDictionary() {
    await api.dataDictionary
      .getDataDictionaryListByKey({ key: "TrainType", maxResultCount: 1000 })
      .then((res: DataDictionaryDtoPagedResultDto) => {
        this.typeList = res.items!;
      });
  }

  // 报名签到明细页
  handleSummary(item: any) {
    this.$router.push({name: 'trainApplySummary', params: {'id': item.id!.toString()}})
  }
}
